import React from 'react';

import Page from 'components/Page';

import './style.css';

const InterestConfirmed = () => (
  <section className="pageContainer">
    <Page>
      <section styleName="inviteContainer">
        <img src="/images/tick.svg" alt="Yup" />
        <h2>You committed to invest</h2>
        <section styleName="messages" data-test="confirmation" >
          <p styleName="transfer">
            We&#39;ll let you know when it&#39;s time to transfer funds.
          </p>
          <p styleName="limited">
            Space is limited, so your actual investment amount may be lower than requested.
          </p>
        </section>
      </section>
      <p styleName="logout">Since you’re done we’ve automatically logged you out</p>
    </Page>
  </section>
);

export default InterestConfirmed;



// WEBPACK FOOTER //
// ./web/flows/interest/confirmed/component.js